import { useMemo } from 'react';

import { Components } from '@sravni/vitrina/lib/enums/Components';
import getDictionaryValue from '@sravni/vitrina/lib/helpers/getDictionaryValue';
import type IProduct from '@sravni/vitrina/lib/types/IProduct';

import { useDictionaries, useProductConfig } from '../../../../../store/hooks/productPopupInfo';

export const usePaymentNetwork = (product: IProduct) => {
  const config = useProductConfig();
  const dictionaries = useDictionaries();

  const paymentNetwork = useMemo(
    () =>
      getDictionaryValue(
        product,
        {
          property: 'paymentNetworks',
          dataSource: 'paymentNetworks',
          component: Components.Dictionary,
        },
        config,
        dictionaries,
      ),
    [config, dictionaries, product],
  );

  return { paymentNetwork };
};
